import { render, staticRenderFns } from "./KparcelBuyView.vue?vue&type=template&id=72057004"
import script from "./KparcelBuyView.vue?vue&type=script&lang=js"
export * from "./KparcelBuyView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports